import React from "react";

// components
import { Redirect, Prompt, NavLink } from "react-router-dom";
import { Link } from 'react-router-dom';
import Header from "../../components/Header";
import TextInput from "../../components/Form/components/TextInput";
import SelectInput from "../../components/Form/components/SelectInput";
import CheckboxInput from "../../components/Form/components/CheckboxInput";
import PassTips from "../../components/HelpTip/passwordHint";
import LoadingSpinner from "../../components/LoadingSpinner";
import UserTable from "./components/UserTable";
import PageTitle from "../../components/PageTitle";
import NotFound from "../NotFound";
import UserAutoComplete from "../../components/Form/components/AutoCompleteInput/UserAutoComplete";
import NavigationBar from "../Navigation";

//services
import withAuth from "../../services/withAuth";
import MembersApi from "../../services/portal-api/MembersApi";
import AuthService from "../../services/AuthService";
import RestartQueue from "../AdminTools/components/components/RestartQueue";

class NewUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            data: {
                user: '',
                uname: '',
                password: '',
                passwordRe: '',
                country: '',
                admin: '',
                timeoutPeriod: 0,
                useGlobal: true,
                resetPassword: true,
                instances: [],
                store: '',
            },
            errors: {},
            users: [],
            filteredUsers: [],
            paginatedUsers: [],
            stores: [],
            isFiltering: false,
            viewSlug: null,
            passwordmandatory: true,
            tempUName: '',
            showTextbox: true,
            addExistingUser: 0,
            currentPage: 1,
            itemsPerPage: 50,
            totalUsers: 0,
            sortKey: 'username',
            sortValue: 'ASC',
        }

        this.handleDynamicPlusClick = this.handleDynamicPlusClick.bind(this);
        this.handleDynamicMinusClick = this.handleDynamicMinusClick.bind(this);
        this.handleUserSelected = this.handleUserSelected.bind(this);
    }

    componentDidMount() {
        document.title = "Users - DuskPortal";
        document.body.className = "page--green";
        if (AuthService.can('users') || (AuthService.can('view store users') && AuthService.getAdminType() == 4)) {
            this.loadUsers();
            this.stores();
        }
        console.log("(AuthService.can('Is change password at next login mandatory') && AuthService.getAdminType() == 4)", (AuthService.can('Is change password at next login mandatory') && AuthService.getAdminType() == 4))
    }

    stores = () => {
        const isAdminType4 = AuthService.getAdminType() == 4;
        const handleFetchStores = (result) => {
            if (result.status === 401) {
                this.props.sessionExpired();
                return;
            }

            const stores = result.json.map((i) => ({
                key: i.id,
                value: i.name,
            }));

            this.setState({
                stores: stores,
            }, () => {
                console.log('fetching all stores...');
            });
        };

        if (isAdminType4) {
            MembersApi.fetchStoresOfAM(handleFetchStores, AuthService.getUserId());
        } else {
            MembersApi.fetchAllStores(handleFetchStores);
        }

    };

    loadUsers() {
        const isAdminType4 = AuthService.getAdminType() == 4;
        const handleFetchUsers = (result) => {
            if (result.status === 401) {
                this.props.sessionExpired();
                return;
            } else {
                const paginatedUsers = AuthService.isAdmin() ? result.json.data : result.json;

                this.setState({
                    users: AuthService.isAdmin() ? result.json.data : result.json,
                    totalUsers: AuthService.isAdmin() ? result.json.total : result.json.length,
                    paginatedUsers: paginatedUsers
                }, () => {
                    console.log('fetching all users...');
                });
            }
        }
        if (isAdminType4) {
            MembersApi.fetchUsersOfAM(handleFetchUsers, AuthService.getUserId());
        } else {
            MembersApi.fetchAllUsers(handleFetchUsers, null, this.state.currentPage, null, null, null, `${this.state.sortKey}-${this.state.sortValue}`);
        }
    }

    removeUser = (id) => {
        const updateFilteredUsers = this.state.filteredUsers.filter(user => user.id !== id);
        const updatePaginatedUsers = this.state.paginatedUsers.filter(user => user.id !== id);
        const updatedUsers = this.state.users.filter(user => user.id !== id);

        this.setState({
            users: updatedUsers,
            filteredUsers: updateFilteredUsers,
            paginatedUsers: updatePaginatedUsers
        });
    }

    searchUsers = (users) => {
        let filteredData = [];
        if (AuthService.isAdmin()) {
            const handleFetchUsers = (result) => {
                if (result.status === 401) {
                    this.props.sessionExpired();
                    return;
                } else {
                    const paginatedUsers = result.json.data;
                    this.setState({
                        totalUsers: result.json.total,
                        filteredUsers: result.json.data,
                        isFiltering: users.length == 0 ? false : true,
                        paginatedUsers: paginatedUsers
                    }, () => {
                        console.log('fetching all users...');
                    });
                }
            }

            MembersApi.fetchAllUsers(handleFetchUsers, null, null, users, null, null, `${this.state.sortKey}-${this.state.sortValue}`);

        } else {
            filteredData = this.state.users.filter(user => user.name.toLowerCase().includes(users.toLowerCase()));
            this.setState({
                filteredUsers: filteredData,
                isFiltering: filteredData.length == this.state.users.length ? false : true
            }, () => {
                console.log("searching users...", filteredData.length);
            });
        }
    }

    searchStore = (store) => {
        if (AuthService.isAdmin()) {
            const handleFetchUsers = (result) => {
                if (result.status === 401) {
                    this.props.sessionExpired();
                    return;
                } else {
                    const paginatedUsers = result.json.data;
                    this.setState({
                        totalUsers: AuthService.isAdmin() ? result.json.total : result.json.length,
                        filteredUsers: result.json.data,
                        isFiltering: store.length == 0 ? false : true,
                        paginatedUsers: paginatedUsers
                    }, () => {
                        console.log('fetching store...');
                    });
                }
            }

            MembersApi.fetchAllUsers(handleFetchUsers, null, null, null, store, null, `${this.state.sortKey}-${this.state.sortValue}`);
        } else {
            const filteredData = this.state.users.filter(user =>
                user.associatedStores.some(result => result.storeId == store)
            );

            this.setState({
                filteredUsers: filteredData,
                isFiltering: filteredData.length == this.state.users.length ? false : true
            }, () => {
                console.log("searching store...");
            });
        }
    }

    searchRole = (role) => {
        if (AuthService.isAdmin()) {
            const handleFetchUsers = (result) => {
                if (result.status === 401) {
                    this.props.sessionExpired();
                    return;
                } else {
                    const paginatedUsers = result.json.data;
                    this.setState({
                        totalUsers: AuthService.isAdmin() ? result.json.total : result.json.length,
                        filteredUsers: result.json.data,
                        isFiltering: role.length == 0 ? false : true,
                        paginatedUsers: paginatedUsers,
                        currentPage: AuthService.isAdmin() ? result.json.current_page : 1
                    }, () => {
                        console.log('fetching role...');
                    });
                }
            }

            MembersApi.fetchAllUsers(handleFetchUsers, null, null, null, null, role, `${this.state.sortKey}-${this.state.sortValue}`);
        } else {
            if(role == 0) {
                role = 'Store User';
            } else if(role == 1) {
                role = 'Super Admin';
            } else if (role == 2) {
                role = 'Store Admin';
            } else if(role == 3) {
                role = 'CS Admin';
            } else if(role == 4) {
                role = 'Area Manager';
            }

            const filteredData = this.state.users.filter(user =>
                user.associatedStores.some(result => result.role == role)
            );

            this.setState({
                filteredUsers: filteredData,
                isFiltering: true
            }, () => {
                console.log("Sort...");
            });
        }
    }

    sort = (column, username, store, role) => {
        this.setState(prevState => ({
            sortValue: prevState.sortValue === "ASC" ? "DESC" : "ASC",
            sortKey: column
        }), () => {
            if (AuthService.isAdmin()) {
                const handleFetchUsers = (result) => {
                    if (result.status === 401) {
                        this.props.sessionExpired();
                        return;
                    } else {
                        const paginatedUsers = result.json.data;

                        this.setState({
                            totalUsers: AuthService.isAdmin() ? result.json.total : result.json.length,
                            filteredUsers: result.json.data,
                            isFiltering: role.length == 0 ? false : true,
                            paginatedUsers: paginatedUsers,
                            currentPage: AuthService.isAdmin() ? result.json.current_page : 1
                        }, () => {
                            console.log(`Sorting ${this.state.sortValue}...`);
                        });
                    }
                }
    
                MembersApi.fetchAllUsers(handleFetchUsers, null, null, username, store, role, `${this.state.sortKey}-${this.state.sortValue}`);
            } else {
                console.log("test role: ",role);
                let filteredData = [...this.state.users];

                const sortKey = (this.state.sortKey == 'last_logged_in_time') ? 'createdOn' : this.state.sortKey;
                
                if(sortKey == 'createdOn') {
                    if (this.state.sortValue === 'ASC') {
                        filteredData.sort((a, b) => {
                            if (a.createdOn === '') {
                            return 1; 
                            } else if (b.createdOn === '') {
                            return -1;
                            }
                    
                            const dateA = new Date(a.createdOn.split('/').reverse().join('/'));
                            const dateB = new Date(b.createdOn.split('/').reverse().join('/'));
                            return dateA - dateB;
                        });
                    } else {
                        filteredData.sort((a, b) => {
                            if (a.createdOn === '') {
                            return -1; 
                            } else if (b.createdOn === '') {
                            return 1; 
                            }
                    
                            const dateA = new Date(a.createdOn.split('/').reverse().join('/'));
                            const dateB = new Date(b.createdOn.split('/').reverse().join('/'));
                            return dateB - dateA;
                        });
                    }
                } else {
                    filteredData.sort((a, b) => {
                        const usernameA = a[sortKey].toUpperCase();
                        const usernameB = b[sortKey].toUpperCase();
                  
                        if (this.state.sortValue === "ASC") {
                          return usernameA.localeCompare(usernameB);
                        } else {
                          return usernameB.localeCompare(usernameA);
                        }
                    });
                }
                
                if(store != '') {
                    const filteredByStore = filteredData.filter(user =>
                        user.associatedStores.some(result => result.storeId == store)
                    );

                    filteredData = filteredByStore; 
                }
                
                if(role != '' || role == 0) {
                    if(role == 0) {
                        role = 'Store User';
                    } else if(role == 1) {
                        role = 'Super Admin';
                    } else if(role == 2) {
                        role = 'Store Admin';
                    } else if(role == 3) {
                        role = 'CS Admin';
                    } else if(role == 4) {
                        role = 'Area Manager';
                    }
                    
                    const filterByRole = filteredData.filter(user =>
                        user.associatedStores.some(result => result.role == role)
                    );

                    filteredData = filterByRole; 
                }

                if(username != '') {
                    const filterByUsername = filteredData.filter(user =>
                        user.username.toUpperCase().includes(username.toUpperCase())
                    );
                    filteredData = filterByUsername; 
                }

                this.setState({
                    filteredUsers: filteredData,
                    isFiltering: true
                }, () => {
                    console.log("Sort...");
                });
            }
        });
    }

    

    handlePageChange = (pageNumber, state, role) => {
        // const { itemsPerPage } = this.state;
        // const startIndex = (pageNumber - 1) * itemsPerPage;
        // const endIndex = startIndex + itemsPerPage;
        
        const handleFetchUsers = (result) => {
            if (result.status === 401) {
                this.props.sessionExpired();
                return;
            } else {
                const paginatedUsers = result.json.data;

                this.setState({
                    users: result.json.data,
                    totalUsers: result.json.total,
                    paginatedUsers: paginatedUsers,
                    currentPage: result.json.current_page,
                    filteredUsers: result.json.data
                }, () => {
                    console.log(this.state.paginatedUsers);
                    // this.forceUpdate();
                });
            }
        }
        MembersApi.fetchAllUsers(handleFetchUsers, null, pageNumber, null, state, role, `${this.state.sortKey}-${this.state.sortValue}`);
    }

    updateIsActive = () => {
        this.loadUsers();
    }

    admins = () => {
        return [
            {
                key: "store_admin",
                value: "Store Admin"
            },
            {
                key: "user",
                value: "Store User"
            }
        ];
    };

    adminsWithCustomerSupport = () => {
        if (AuthService.isAdmin()) {
            return [
                {
                    key: "super_admin",
                    value: "Super Admin"
                },
                {
                    key: "cs_admin",
                    value: "Customer Support Admin"
                },
                {
                    key: "user",
                    value: "Store User"
                }
            ];
        } else if (AuthService.getAdminType() == 3) {
            return [
                {
                    key: "cs_admin",
                    value: "Customer Support Admin"
                },
                {
                    key: "user",
                    value: "Store User"
                }
            ];
        } else {
            [];
        }
    }

    handleDynamicPlusClick = () => {
        const { instances } = this.state.data;

        const newInstances = [...instances, { store: '', admin: '' }];

        this.setState(prevState => ({
            data: {
                ...prevState.data,
                instances: newInstances,
            },
        }));
    };

    handleStoreChange = (event, index) => {
        const { value } = event.target;
        this.setState(prevState => {
            const updatedInstances = [...prevState.data.instances];
            updatedInstances[index].store = value;
            return {
                data: {
                    ...prevState.data,
                    instances: updatedInstances,
                },
            };
        });
    };

    handleAdminChange = (event, index) => {
        const { value } = event.target;
        this.setState(prevState => {
            const updatedInstances = [...prevState.data.instances];
            updatedInstances[index].admin = value;
            return {
                data: {
                    ...prevState.data,
                    instances: updatedInstances,
                },
            };
        });
    };

    handleDynamicMinusClick = (index) => {
        this.setState(prevState => ({
            data: {
                ...prevState.data,
                instances: prevState.data.instances.filter((_, i) => i !== index),
            },
        }), () => {
            console.log(`Dynamic dropdpown removed at index ${index}`);
        });
    };

    handleUserSelected(uname) {
        const { data } = this.state;
        data['uname'] = uname.uname.value;
        this.setState({
            data: data,
            passwordmandatory: false,
            tempUName: uname.uname.value,
            showTextbox: false,
            addExistingUser: 1
        });
    }

    handleInput = (event, index, fieldName) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        let data = this.state.data;
        let passwordmandatory = this.state.passwordmandatory;
        let showTextbox = this.state.showTextbox;
        let addExistingUser = this.state.addExistingUser;
        if (name == "timeoutPeriod") {
            data[name] = event.target.value == '' ? 0 : event.target.value;
            if (isNaN(data[name]) || data[name] < 0) {
                errors["timeoutPeriod"] = "The Inactivity Timeout needs to be a valid number greater than 0.";
            }
        } else if (name == "useGlobal") {
            data[name] = event.target.checked;
            data["timeoutPeriod"] = data[name] ? 0 : data["timeoutPeriod"];
            delete errors["timeoutPeriod"];
        } else if (name == "uname") {
            if (this.state.tempUName != event.target.value) {
                passwordmandatory = true;
                data[name] = event.target.value;
                showTextbox = true;
                addExistingUser = 0;
            }
        } else {
            data[name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        }

        this.setState({
            data: data,
            errors: errors,
            isEdited: true,
            passwordmandatory: passwordmandatory,
            showTextbox: showTextbox,
            addExistingUser: addExistingUser
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const { admin } = this.state.data;

        let passwordValidDefinition = [
            {
                minLength: 6,
                ErrorMessage: "Your password must be at least six characters long.",
            },
            {
                maxLength: 50,
                ErrorMessage: "Your password cannot be longer than 50 characters.",
            },
            {
                regex: /.*\d/,
                ErrorMessage: "Your password must contain at least one digit.",
            },
            {
                regex: /.*[a-zA-Z]/,
                ErrorMessage: "Your password must contain at least one letter.",
            },
            {
                regex: /.*[!@#$%^&*() =+_-]/,
                ErrorMessage: "Your password must contain at least one symbol in this list !@#$%^&*()=+_- or a space.",
            },
        ];

        let password = this.state.data.password;
        let isvalid = true;
        const errors = this.state.errors;
        delete errors["regex"];
        delete errors["minLength"];
        delete errors["maxLength"];
        delete errors["reConfirm"];
        delete errors["admin"];
        delete errors["error"];

        if (this.state.passwordmandatory == true) {
            if (password != this.state.data.passwordRe) {
                errors["reConfirm"] = "The confirmation password does not match or is empty.";
                isvalid = false;
            }


            for (let i = 0; i < passwordValidDefinition.length; i++) {
                let validator = passwordValidDefinition[i];

                if (validator.hasOwnProperty("regex")) {
                    if (password.search(validator.regex) < 0) {
                        errors["regex"] = validator.ErrorMessage; isvalid = false;
                    }

                }

                if (validator.hasOwnProperty("minLength")) {
                    if (password.length < validator.minLength) {
                        errors["minLength"] = validator.ErrorMessage; isvalid = false;
                    }
                }

                if (validator.hasOwnProperty("maxLength")) {
                    if (password.length > validator.maxLength) {
                        errors["maxLength"] = validator.ErrorMessage; isvalid = false;
                    }
                }

            }

            this.setState({
                errors: errors,
                viewSlug: null
            });


            if (!isvalid) {
                window.scrollTo(0, 0);
                return false;
            }
        }

        if (errors["timeoutPeriod"] != undefined) {
            return false;
        }

        // const sendParams = this.state.data;
        const { instances } = this.state.data;
        let serializedInstances = [];

        if (instances.length > 0) {
            for (const instance of instances) {
                if ((instance.store != '' && instance.store != null) && (instance.admin != '' && instance.admin != null)) {
                    if (instance.admin == 'super_admin') { // remove other stores and roles if super_admin is present in the admin property of any of the array of objects
                        serializedInstances = [];
                        serializedInstances.push({
                            store: sessionStorage.getItem('site') == 'AU' ? '1' : '20001',
                            admin: 'super_admin',
                        });
                        break;
                    }
                    serializedInstances.push({
                        store: instance.store,
                        admin: instance.admin,
                    })
                } else {
                    swal("Either a store or a role or both are not selected", {
                        icon: "warning",
                        buttons: false,
                        timer: 3000
                    });

                    return false;
                }
            }
        }
        console.log("489 ", serializedInstances);
        if (serializedInstances.some(item => item.admin != 'super_admin') || serializedInstances.length == 0) {
            if (this.state.data.store != '' && this.state.data.admin != '') {
                if (this.state.data.admin == 'super_admin') { // remove other stores and roles if super_admin is present in the admin property of any of the array of objects
                    serializedInstances = [];
                }
                serializedInstances.push({
                    store: this.state.data.store,
                    admin: this.state.data.admin,
                });
            }

        }

        console.log("500 ", serializedInstances)

        const sendParams = {
            ...this.state.data,
            instances: JSON.stringify(serializedInstances),
            addExistingUser: this.state.addExistingUser,
        };

        if (!AuthService.isAdmin()) {
            delete sendParams['timeoutPeriod'];
        }


        if (serializedInstances.length == 0) {
            this.setState({
                isLoading: false
            });

            swal("Atleast a store and role should be selected", {
                icon: "warning",
                buttons: false,
                timer: 3000
            });

            return false;
        }

        // Show loading and reset state
        this.setState({
            isLoading: true,
            errors: {},
        });

        // Fetch data
        MembersApi.multiAddUser(sendParams, (response) => {
            if (response.success) {
                // Redirect away
                const { data } = this.state;
                data.uname = '';
                data.password = '';
                data.passwordRe = '';
                data.resetPassword = true,
                    data.email = '';
                data.store = '';
                data.admin = '';
                data.timeoutPeriod = 0;
                data.instances = [];
                data.passwordmandatory = true;
                data.tempUName = '';

                this.setState({
                    isLoading: false,
                    isEdited: false,
                    data: data,
                    viewSlug: response.json.message,
                }, () => {
                    this.loadUsers();
                });
            }
            else {
                // Check for auth
                if (response.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoading: false,
                        viewSlug: null
                    });
                    return;
                }

                if (response.json.errors) {
                    this.setState({
                        isLoading: false,
                        errors: response.json.errors,
                        viewSlug: null
                    });
                }
                else if (response.json.error) {
                    this.setState({
                        isLoading: false,
                        errors: { error: response.json.error },
                        viewSlug: null
                    });
                }
                else {
                    this.setState({
                        isLoading: false,
                        viewSlug: null
                    });
                }
            }
            window.scrollTo(0, 0);
        });
    }

    render() {
        const instances = this.state.data.instances.map((instance, index) => (
            <React.Fragment key={index}>
                <div className="col">
                    <SelectInput
                        name={`store[${index}]`}
                        label=""
                        value={instance.store}
                        error={this.state.errors.store}
                        onChange={event => this.handleStoreChange(event, index)}
                        options={this.state.stores}
                        required={true}

                    />
                </div>
                <div className="col">
                    <div className="col-2 gutter--40">
                        <div className="col">
                            <SelectInput
                                name={`admin[${index}]`}
                                label=""
                                options={instance.store == "1" || instance.store == "20001" ? this.adminsWithCustomerSupport() : this.admins()}
                                value={instance.admin}
                                error={this.state.errors.admin}
                                onChange={event => this.handleAdminChange(event, index)}
                                required={true}

                            />
                        </div>
                        <div className="col">
                            <span className="sub-title text--grey"></span>
                            <br />
                            <button
                                type="button"
                                name="dynamicBtn"
                                className="btn btn--xsmall btn--color"
                                onClick={() => this.handleDynamicMinusClick(index)}
                            >
                                -
                            </button>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        ));

        // const { instances } = this.state.data;

        const viewUrl = AuthService.isAdmin() ? '/admintools' : '/';
        let c = '';

        if (this.state.viewSlug) {
            console.log(this.state.viewSlug);
            c = <div className="alert alert--success alert--outline text--center margin--20">{this.state.viewSlug}</div>
        }

        const errorsmsg = [];
        for (const [key, value] of Object.entries(this.state.errors)) {
            errorsmsg.push(<li key={key}><span>Sorry, <strong>{value}</strong> Please try again, or contact Super Admin if the problem persists.</span></li>);
        }

        let loaderOffset = {
            top: 200,
            position: 'absolute',
            left: '50%',
        }

        return (
            // AuthService.getAdminType() == 1 || AuthService.getAdminType() == 4 ?
            AuthService.can('users') || (AuthService.can('store users') && AuthService.getAdminType() == 4) ?
                <div>
                    <Header />
                    <main className="content padding--80--bot" role="main">
                        <div className="container container--wide padding--40">
                            {AuthService.getAdminType() == 1 &&
                                <div className="info-wrap col gutter--40 margin--10--bot" style={{ borderBottom: "1px solid #ccc" }}>
                                    <div className="col">
                                        <NavigationBar />
                                    </div>

                                </div>
                            }

                            <h2 className="text--light text--color text--40">Users</h2>
                            {errorsmsg.length > 0 && <ul className="alert alert--outline alert--error margin--40--top">
                                {errorsmsg}
                            </ul>}
                            {c}

                            {(AuthService.can('create users') || (AuthService.can('create store users') && AuthService.getAdminType() == 4)) &&

                                <form onSubmit={this.handleSubmit} className={AuthService.getAdminType() == 1 || AuthService.getAdminType() == 4 ? "validate loading--inline " : "margin--40--top validate loading--inline padding--90--bot"} autoComplete="off">
                                    <span></span>
                                    <div className="col-2 gutter--40 ">
                                        <div className="col">
                                            {AuthService.getAdminType() == 1 &&
                                                <TextInput
                                                    name="uname"
                                                    label="Username"
                                                    value={this.state.data.uname}
                                                    error={this.state.errors.uname}
                                                    onChange={this.handleInput}
                                                    required={true}
                                                />}
                                            {AuthService.getAdminType() == 4 &&
                                                <UserAutoComplete
                                                    name="uname"
                                                    label="Username"
                                                    value={this.state.data.uname}
                                                    error={this.state.errors.uname}
                                                    onChange={this.handleInput}
                                                    onSuburbSelected={this.handleUserSelected}
                                                />
                                            }
                                        </div>
                                        {(AuthService.getAdminType() == 1 || AuthService.getAdminType() == 4) &&
                                            <div className="col">
                                                <div className="col-2 gutter--40 ">
                                                    <div className="col">
                                                        <TextInput
                                                            type="text"
                                                            name="timeoutPeriod"
                                                            label="Inactivity Timeout (Mins)"
                                                            placeholder="Enter minutes..."
                                                            value={this.state.data.timeoutPeriod == 0 ? '' : this.state.data.timeoutPeriod}
                                                            error={this.state.errors.timeoutPeriod}
                                                            onChange={this.handleInput}
                                                            required={false}
                                                            disabled={this.state.data.useGlobal ? true : false}
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <CheckboxInput
                                                            name="useGlobal"
                                                            title=""
                                                            label={"Use global timeout settings"}
                                                            isChecked={this.state.data.useGlobal}
                                                            onChange={this.handleInput}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showTextbox && <React.Fragment><div className="col">
                                            <TextInput
                                                type="password"
                                                name="password"
                                                label="Password"
                                                value={this.state.data.password}
                                                error={this.state.errors.password}
                                                onChange={this.handleInput}
                                                required={this.state.passwordmandatory}
                                                tooltip={<PassTips>
                                                    <ul>
                                                        <li><span>Your password must be at least six characters long.</span></li>
                                                        <li><span>Your password must contain at least one digit and one letter</span></li>
                                                        <li><span>Your password must contain at least one symbol in this list !@#$%^&*()=+_- or a space.</span></li>
                                                    </ul>
                                                </PassTips>}
                                            />
                                        </div>
                                            <div className="col">
                                                <div className="col-2 gutter--40 ">
                                                    <div className="col">
                                                        <TextInput
                                                            type="password"
                                                            name="passwordRe"
                                                            label="Re-confirm Password"
                                                            value={this.state.data.passwordRe}
                                                            error={this.state.errors.passwordRe}
                                                            onChange={this.handleInput}
                                                            required={this.state.passwordmandatory}
                                                            tooltip={<PassTips>
                                                                <ul>
                                                                    <li><span>Your password must be at least six characters long.</span></li>
                                                                    <li><span>Your password must contain at least one digit and one letter</span></li>
                                                                    <li><span>Your password must contain at least one symbol in this list !@#$%^&*()=+_- or a space.</span></li>
                                                                </ul>
                                                            </PassTips>}
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        {AuthService.isAdmin() ?
                                                            <CheckboxInput
                                                                name="resetPassword"
                                                                title=""
                                                                label={"Change password at next login"}
                                                                isChecked={this.state.data.resetPassword}
                                                                onChange={this.handleInput}
                                                            />
                                                        :
                                                            AuthService.can('Is change password at next login mandatory') && AuthService.getAdminType() == 4 ?
                                                                <CheckboxInput
                                                                    name="resetPassword"
                                                                    title=""
                                                                    label={"Change password at next login"}
                                                                    isChecked={this.state.data.resetPassword}
                                                                    onChange={this.handleInput}
                                                                    disabled={true}
                                                                />
                                                                :
                                                                <CheckboxInput
                                                                    name="resetPassword"
                                                                    title=""
                                                                    label={"Change password at next login"}
                                                                    isChecked={this.state.data.resetPassword}
                                                                    onChange={this.handleInput}
                                                                    disabled={false}
                                                                />
                                                        }
                                                    </div>
                                                </div>
                                            </div></React.Fragment>}
                                        <div className="col">
                                            <SelectInput
                                                name="store"
                                                label="Store"
                                                options={this.state.stores}
                                                value={this.state.data.store}
                                                error={this.state.errors.store}
                                                onChange={this.handleInput}
                                                required={true}

                                        />
                                    </div>
                                    <div className="col">
                                        <div className="col-2 gutter--40 ">
                                            <div className="col">
                                                <SelectInput
                                                    name="admin"
                                                    label="User Type"
                                                    options={this.state.data.store == "1" || this.state.data.store == "20001" ? this.adminsWithCustomerSupport() : this.admins()}
                                                    value={this.state.data.admin}
                                                    error={this.state.errors.admin}
                                                    onChange={this.handleInput}
                                                    required={true}

                                                    />
                                                </div>
                                                <div className="col">
                                                    <span className="sub-title text--grey">Assign To  Store</span><br />
                                                    <button
                                                        type="button"
                                                        name="dynamicBtn"
                                                        className="btn btn--xsmall btn--color"
                                                        onClick={this.handleDynamicPlusClick}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {instances}

                                        <footer className="footer--form clearfix">
                                            <div className="footer--form__left">

                                            </div>
                                            <div className="footer--form__right">
                                                <button type="submit" className="btn btn--large btn--color">Add User</button>
                                            </div>
                                        </footer>
                                    </div>
                                </form>
                            }

                            {(AuthService.can('View users') || (AuthService.can('view store users') && AuthService.getAdminType() == 4)) &&
                                <UserTable
                                    removeUser={this.removeUser}
                                    updateIsActive={this.updateIsActive}
                                    searchUsers={this.searchUsers}
                                    filteredUsers={this.state.filteredUsers}
                                    paginatedUsers={this.state.paginatedUsers}
                                    stores={this.state.stores}
                                    searchStore={this.searchStore}
                                    searchRole={this.searchRole}
                                    sort={this.sort}
                                    isFiltering={this.state.isFiltering}
                                    handlePageChange={this.handlePageChange}
                                    currentPage={this.state.currentPage}
                                    itemsCountPerPage={this.state.itemsPerPage}
                                    totalUsers={this.state.totalUsers}
                                />
                            }

                            {this.state.isLoading && <div style={{ position: 'absolute', height: '100%', width: '100%', top: 0, background: '#fff', zIndex: 7777, opacity: 0.8 }}>
                                <div className="sk-fading-circle" style={loaderOffset}>
                                    <div className="sk-circle1 sk-circle" />
                                    <div className="sk-circle2 sk-circle" />
                                    <div className="sk-circle3 sk-circle" />
                                    <div className="sk-circle4 sk-circle" />
                                    <div className="sk-circle5 sk-circle" />
                                    <div className="sk-circle6 sk-circle" />
                                    <div className="sk-circle7 sk-circle" />
                                    <div className="sk-circle8 sk-circle" />
                                    <div className="sk-circle9 sk-circle" />
                                    <div className="sk-circle10 sk-circle" />
                                    <div className="sk-circle11 sk-circle" />
                                    <div className="sk-circle12 sk-circle" />
                                </div>
                            </div>}
                        </div>
                    </main>
                    <LoadingSpinner isVisible={this.state.isLoading} />
                </div>
                : <NotFound forbidden={true} />
        );
    }
}

export default withAuth(NewUsers);